<script setup>
import UserMain from "@/Views/Includes/UserMain.vue";
import Footer from "@/Views/Includes/FooterSection.vue";
</script>

<template>
  <UserMain></UserMain>
  <router-view></router-view>
  <Footer></Footer>
</template>

<style scoped>
nav {
  gap: 10px;
  margin-bottom: 30px;
}
</style>